<template>
	<div>
		<!--    <a-form
        ref="ruleForm"
        :model="queryParams"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      > -->
		<!-- <a-form-item label="坐标获取结果">
          <a-input
            v-model="queryParams.longitudeAndLatitude"
            placeholder="坐标获取结果"
            disabled
            ref="inputRef"
            allowClear
          />
        </a-form-item> -->
		<!-- <a-form-item label="按关键字搜索">
          
        </a-form-item>
      </a-form> -->
		<a-select v-model="queryParams.keyword" showSearch placeholder="按关键字搜索" style="width: 100%"
			:defaultActiveFirstOption="false" :showArrow="false" :filterOption="false" @search="remoteMethod"
			@change="selectChang" :notFoundContent="null">
			<a-select-option v-for="item in searchArr" :key="item.value" :label="item.label" :value="item.value">
				{{ item.label }}</a-select-option>
		</a-select>
		<div class="mapContent" id="pointMap"></div>

	</div>
</template>
<script>
	import AMap from 'AMap'
	export default {
		props: ['addrs','maps'],
		name: 'CoordinatePick',
		data() {
			return {
				queryParams: {
					keyword: '',
					longitudeAndLatitude: ''
				},
				fetching: false,
				searchArr: [],
				Map: null,
				open: false,
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 20
				}
			}
		},
		mounted() {
			if (this.maps) {
				this.queryParams.keyword = this.addrs.addrs
			}
			let maps = this.maps.join(',')
			this.initMap(maps);
		},
		methods: {
			initMap(longitudeAndLatitude) {
				let self = this;
				this.open = true
				this.$nextTick(() => {
					if (this.Map) {
						this.Map.clearMap()
					}
					this.Map = new AMap.Map('pointMap', {
						// 设置地图容器id
						// viewMode: "3D",    //是否为3D地图模式
						draggable: false,
						zoom: 15, // 初始化地图级别
						center: [104.07275, 30.57899], //初始化地图中心点位置
					})
					if (longitudeAndLatitude) {
						// 之前有坐标，需要处理回显
						this.queryParams.longitudeAndLatitude = longitudeAndLatitude

						// 创建一个 Marker 实例：
						const marker = new AMap.Marker({
							draggable: false,
							position: new AMap.LngLat(
								Number(longitudeAndLatitude.split(',')[0]),
								Number(longitudeAndLatitude.split(',')[1])
							) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
						})
						this.Map.add(marker)
						this.Map.setCenter([Number(longitudeAndLatitude.split(',')[0]),longitudeAndLatitude.split(',')[1]]);
					}
					this.Map.on('click', (e) => {

						this.Map.clearMap()
						this.queryParams.longitudeAndLatitude = e.lnglat.lng + ',' + e.lnglat.lat
						const marker = new AMap.Marker({
							draggable: false,
							position: new AMap.LngLat(e.lnglat.lng, e.lnglat
								.lat) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
						})
						this.Map.add(marker)
		 			let geocoder = new AMap.Geocoder({});
						geocoder.getAddress(e.lnglat, function(status, result) {
							if (status === "complete" && result.regeocode) {
								self.queryParams.keyword = result.regeocode.formattedAddress;
								self.$emit('change',{
										lnglat: self.queryParams.longitudeAndLatitude,
										addrs: result.regeocode.formattedAddress,
								})
							} else {
								console.log.error("根据经纬度查询地址失败");
							}
						});
						
						
					})
					
				})
			},
			remoteMethod(query) {
				console.log(query, 'query')
				if (query) {
					AMap.plugin('AMap.Autocomplete', () => {
						// 实例化Autocomplete
						var autoOptions = {
							city: '全国'
						}
						var autoComplete = new AMap.Autocomplete(autoOptions)
						autoComplete.search(query, (status, result) => {
							if (result && result.info === 'OK') {
								this.searchArr = result.tips
									.map((v) => {
										if (v.location) {
											return {
												label: v.name,
												value: v.location.lng + ',' + v.location.lat
											}
										}
									})
									.filter((ele) => ele)
							}

							console.log('this.searchArr--->',this.searchArr);
						})
					})
				} else {
					this.searchArr = []
				}
			},
			handleSubmit() {
				this.$emit('lngLatChange', this.queryParams.longitudeAndLatitude)
				this.open = false
			},
			selectChang(v,l) {
				if (this.Map) {
					this.Map.clearMap()
				}
				// let addrs=this.queryParams.keyword
				this.queryParams.longitudeAndLatitude=this.queryParams.keyword
				// 创建一个 Marker 实例：
				const marker = new AMap.Marker({
					draggable: false,
					position: new AMap.LngLat(this.queryParams.keyword.split(',')[0], this.queryParams.keyword
						.split(',')[1]) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
				})
				this.Map.add(marker)
				// this.Map.setFitView()
				this.Map.setCenter([this.queryParams.longitudeAndLatitude.split(',')[0],this.queryParams.longitudeAndLatitude.split(',')[1]]);
				this.$emit('change',{
					lnglat: this.queryParams.longitudeAndLatitude,
					addrs: l.componentOptions.children[0].elm.data.trim(),
				})
			},
			handleCancel(e) {
				console.log('Clicked cancel button')
				this.visible = false
			}
		}
	}
</script>
<style lang="scss" scoped>
	.mapContent {
		width: 100%;
		height: 300px;
		border: 1px #dbdbdb solid;
		border-radius: 3px;
	}

	/deep/ .amap-logo {
		display: none !important;
		visibility: hidden !important;
	}

	/deep/ .amap-copyright {
		display: none !important;
		visibility: hidden !important;
	}
</style>
